import LoadingPage from './LoadingPage.jsx';

export {
  LoadingPage
};



// WEBPACK FOOTER //
// ./components/loading-page/index.js